import React from 'react';
import FormSelect from 'components/FormFields/FormSelect';
import { TIME_ZONES, TIME_ZONES_ORDER } from 'utils/constants';

const CalendarTimeZoneSelect = ({
  timeZone,
  myTimeZone,
  projectTimeZone,
  onTimeZoneChange,
  disabled = false,
  dropdownButtonProps = {},
  displayMyTimezone = false,
  displayProjectTimezone = false,
  name='Time Zone',
  required = false,
}) => {
  return (
    <FormSelect
      name={name}
      value={timeZone}
      onChange={onTimeZoneChange}
      showSearch
      dropdownButtonProps={dropdownButtonProps}
      disabled={disabled}
      required={required}
      responsive={false}
    >
      {timeZoneOptions({ myTimeZone, projectTimeZone, displayMyTimezone, displayProjectTimezone })}
    </FormSelect>
  );
};

const timeZoneOptions = ({ myTimeZone, projectTimeZone, displayMyTimezone, displayProjectTimezone }) => {
  const currentTimeZone = TIME_ZONES.find(tz => tz.value === myTimeZone);
  const _projectTimeZone = TIME_ZONES.find(tz => tz.value === projectTimeZone);
  const timeZones = TIME_ZONES.filter(tz => tz.value !== myTimeZone && tz.value !== projectTimeZone);

  const floatedOptions = [];

  // Sometimes we want to separate out the user's timezone (either app based or browser based)
  // or project timezone and float it to the top. But in the case where we don't, we display
  // the options normally.
  if (!displayMyTimezone && !displayProjectTimezone) {
    return [
      ...TIME_ZONES_ORDER.map((option, index) => (
        <optgroup
          label={option.value}
          key={`option_${index}`}
        >
          {TIME_ZONES.filter((tz) => tz.group === option.value).map(
            (optionTZ, indexTZ) => (
              <option
                value={optionTZ.value}
                key={`optionTZ_${option.value}_${indexTZ}`}
              >
                {optionTZ.label}
              </option>
            ),
          )}
        </optgroup>
      )),
    ];
  }

  if (currentTimeZone) {
    floatedOptions.push(
      <option
        value={currentTimeZone.value}
        key={`optionTZ_${currentTimeZone.value}`}
      >
        {`My Time Zone (${currentTimeZone.label})`}
      </option>,
    );
  }

  if (_projectTimeZone) {
    floatedOptions.push(
      <option
        value={_projectTimeZone.value}
        key={`optionTZ_project_${_projectTimeZone.value}`}
      >
        {`Project Time Zone (${_projectTimeZone.label})`}
      </option>,
    );
  }

  return [
    ...floatedOptions,
    ...TIME_ZONES_ORDER.map((option, index) => (
      <optgroup
        label={option.value}
        key={`option_${index}`}
      >
        {timeZones.filter((tz) => tz.group === option.value).map(
          (optionTZ, indexTZ) => (
            <option
              value={optionTZ.value}
              key={`optionTZ_${option.value}_${indexTZ}`}
            >
              {optionTZ.label}
            </option>
          ),
        )}
      </optgroup>
    )),
  ];
};

export default CalendarTimeZoneSelect;
